<template>
    <div v-if="props.indexGranularity">
        <select-button
            v-model="selectedIndexGranularity"
            :options="INDEX_GRANULARITY_OPTIONS"
            option-label="name"
            option-value="id"
            :allow-empty="false"
            :disabled="props.selectionLocked"
        />
    </div>
    <div v-else>
        <granularity-selector
            v-model="aggregate"
            :selection-locked="props.selectionLocked"
            :index-granularity-warning="props.indexGranularityWarning"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SelectButton from 'primevue/selectbutton';
import { ICombinedAggregateOptions } from '@/interfaces/powerMarkets/charts/IModuleChartConfig.ts';
import { INDEX_GRANULARITY_OPTIONS } from '@/constants/benchmarks/IndexConstants.ts';
import GranularitySelector from '@/components/powerMarkets/date-picker/GranularitySelector.vue';
import { getSupportedIndexGranularity } from '@/utils/benchmarks/indexUtil.ts';

const props = defineProps<{
    indexGranularity?: boolean;
    selectionLocked?: boolean;
    indexGranularityWarning?: string;
}>();

const aggregate = defineModel<ICombinedAggregateOptions>({ required: true });

const selectedIndexGranularity = computed({
    get: () => getSupportedIndexGranularity(aggregate.value.granularity),
    set: (granularity: string) => {
        aggregate.value.granularity = granularity;
    },
});

</script>
